<template>
  <div class="seminar-lodgings-page">
    <!-- Fullscreen Hero Video with Text Overlay -->
		<section class="hero-video">
			<!-- Desktop video -->
			<video
				class="hero-video__bg d-none d-md-block"
				autoplay
				muted
				loop
				playsinline
				poster="https://conversions-api-gateway-9083319738648672-s3bucket-zfjcs6au7hlj.s3.eu-west-3.amazonaws.com/S%C3%A9minaire/seminaire-eco-responsable-image-desktop.jpg"
			>
				<source
					src="https://conversions-api-gateway-9083319738648672-s3bucket-zfjcs6au7hlj.s3.eu-west-3.amazonaws.com/S%C3%A9minaire/seminaire-eco-responsable-desktop.mp4"
					type="video/mp4"
				/>
				<img
					src="https://conversions-api-gateway-9083319738648672-s3bucket-zfjcs6au7hlj.s3.eu-west-3.amazonaws.com/S%C3%A9minaire/seminaire-eco-responsable-image-desktop.jpg"
					alt="Hortense Hero Desktop"
					class="hero-fallback"
				/>
			</video>

			<!-- Mobile video -->
			<video
				class="hero-video__bg d-block d-md-none"
				autoplay
				muted
				loop
				playsinline
				poster="https://conversions-api-gateway-9083319738648672-s3bucket-zfjcs6au7hlj.s3.eu-west-3.amazonaws.com/S%C3%A9minaire/seminaire-eco-responsable-image-mobile.jpg"
			>
				<source
					src="https://conversions-api-gateway-9083319738648672-s3bucket-zfjcs6au7hlj.s3.eu-west-3.amazonaws.com/S%C3%A9minaire/seminaire-eco-responsable-mobile.mp4"
					type="video/mp4"
				/>
				<img
					src="https://conversions-api-gateway-9083319738648672-s3bucket-zfjcs6au7hlj.s3.eu-west-3.amazonaws.com/S%C3%A9minaire/seminaire-eco-responsable-image-mobile.jpg"
					alt="Hortense Hero Mobile"
					class="hero-fallback"
				/>
			</video>

			<!-- <div class="hero-video__content">
				<h1>Hortense for Business</h1>
				<p>Ensemble, organisons votre événements d’entreprise</p>
			</div> -->
		</section>


    <!-- Why Choose Hortense Section -->
		<section class="why-hortense text-center py-5" data-aos="fade-up" data-aos-duration="900">
			<h4 class="mb-2 mobile-title">Pourquoi organiser votre séminaire</h4>
			<h1 class=" mb-5 mobile-sub">avec Hortense ?</h1>

			<!-- Mobile-only horizontal scroll -->
			<div class="benefits-scroll-wrapper d-md-none">
				<!-- Left arrow -->
				<button class="scroll-btn left" @click="scrollBenefitsLeft">
					<img :src="arrows.right" alt="Scroll Left" class="arrow-img flipped zoom-img" />
				</button>

				<!-- Scrollable benefit cards -->
				<div ref="benefitsScroll" class="benefits-slider-mobile">
					<div class="benefit-card zoom-img-containerr" v-for="(benefit, i) in benefits" :key="i">
						<img :src="benefit.image" :alt="benefit.title" class="zoom-img" @click="showModal = true" />
						<p class="raleway-bold-16" style="font-family: 'Raleway'; font-weight: 700; font-size: 16px;">{{ benefit.title }}</p>
						<p>{{ benefit.text }}</p>
					</div>
				</div>

				<!-- Right arrow -->
				<button class="scroll-btn right" @click="scrollBenefitsRight">
					<img :src="arrows.right" alt="Scroll Right" class="arrow-img zoom-img" />
				</button>
			</div>

			<!-- Desktop-only grid -->
			<div class="benefits-grid d-none d-md-grid">
				<div class="benefit-card zoom-img-containerr" v-for="(benefit, i) in benefits" :key="i">
					<img :src="benefit.image" :alt="benefit.title" class="zoom-img" @click="showModal = true" />
					<p class="raleway-bold-16" style="font-family: 'Raleway'; font-weight: 700; font-size: 16px;">{{ benefit.title }}</p>
					<p>{{ benefit.text }}</p>
				</div>
			</div>
			<!-- CTA Button -->
			<div class="mt-4 d-flex justify-content-center">
				<a href="/seminaire-eco-responsable/contact-seminaire" class="cta-button">ORGANISEZ VOTRE ÉVÉNEMENT</a>
			</div>
		</section>


		<!-- Horizontal Destination Masonry Simulation -->
		<section class="destinations-slider text-center" data-aos="fade-up" data-aos-duration="900">
			<h4 class="mb-2 mobile-title">Nos destinations</h4>
			<h1 class=" mb-4 mobile-sub">pour vos séminaires</h1>

			<div class="masonry-scroll-wrapper" data-aos="fade-up" data-aos-duration="900">
				<!-- Left arrow -->
				<button class="scroll-btn left" @click="scrollLeft">
					<img :src="arrows.right" alt="Scroll Left" class="arrow-img flipped zoom-img" />
				</button>

				<!-- Scrollable content -->
				<div ref="masonryScroll" class="horizontal-masonry-scroll" data-aos="fade-up" data-aos-duration="900">
					<div class="masonry-row" v-for="rowIndex in 2" :key="rowIndex" >
						<div
							class="region-card-masonry"
							v-for="(region, index) in regions.filter((_, i) => i % 2 === rowIndex - 1)"
							:key="region.id"
							v-if="region.name"
							:style="{ width: randomWidth(index) + 'px' }"
						>
							<div 
                @click="showModal = true"
								class="region-card-img"
								:style="{ backgroundImage: `url(${regionImage(region)})` }"
							>
								<div class="region-name-overlay">{{ region.name }}</div>
							</div>
						</div>
					</div>
				</div>

				<!-- Right arrow -->
				<button class="scroll-btn right" @click="scrollRight">
					<img :src="arrows.right" alt="Scroll Right" class="arrow-img" />
				</button>
			</div>
		</section>



    <!-- Icon Grid Section -->
    <section class="icon-difference py-5 text-center" style="background-color: #f2f7f3;" data-aos="fade-up" data-aos-duration="900">
      <h4 class="mb-2 mobile-title">Faites le choix d’un séminaire</h4>
      <h1 class=" mb-5 mobile-sub">qui fait la différence</h1>
			<div class="icon-wrapper" data-aos="fade-up" data-aos-duration="900">
				<div class="icon-grid">
					<div class="icon-card zoom-img-containerr" v-for="(icon, index) in icons" :key="index"  :style="{ marginTop: index === 0 || index === 3  ? '1.5vh' : '' }">
						<img :src="icon.image" :alt="icon.alt" />
						<p class="raleway-bold-16" v-html="icon.label"></p>
				</div>
				</div>
			</div>
    </section>

    <section class="seminar-heading text-center mt-2">
        <h4 class="mb-2 mobile-title">Nos lieux exceptionnels</h4>
        <h1 class=" mb-4 mobile-sub">pour vos séminaires</h1>
    </section>

		<!-- Lodgings Showcase -->
		<div class="seminar-lodgings-slider" data-aos="fade-up" data-aos-duration="900">

			<button class="scroll-btn left" @click="scrolllodgingLeft">
			<img :src="arrows.right" alt="Scroll Left" class="arrow-img flipped zoom-img" />
			</button>

			<div class="lodging-slider-wrapper" ref="lodgingScroll">
			<SeminarCard
				v-for="lodging in lodgings"
				:key="lodging.id"
				:lodging="lodging"
				:dataMarker="lodging"
				:user="user"
				:exclusive="lodging.exclusive"
				:wishlistLodgings="wishlistLodgings"
				:lodgingList="lodgings"
			/>
			</div>

			<button class="scroll-btn right" @click="scrolllodgingRight">
			<img :src="arrows.right" alt="Scroll Right" class="arrow-img" />
			</button>

		</div>
    <div class="d-flex justify-content-center">
				<a href="/seminaire-eco-responsable/contact-seminaire" class="cta-button">CRÉEZ VOTRE EXPÉRIENCE</a>
		</div>



		<!-- CTA + Image Section -->
		<section class="eco-cta-section" data-aos="fade-up" data-aos-duration="900">
			<div class="eco-cta-wrapper" data-aos="fade-up" data-aos-duration="900">
				<div class="eco-cta-image zoom-img-containerr" onclick="window.open('https://calendly.com/servicecorporate-hortense/30-minute-meeting-clone', '_blank')" style="cursor: pointer;">
					<img
						src="https://conversions-api-gateway-9083319738648672-s3bucket-zfjcs6au7hlj.s3.eu-west-3.amazonaws.com/S%C3%A9minaire/team-building-hortense.gif"
						alt="Team building Hortense"
					/>
				</div>
				<div class="eco-cta-text" data-aos="fade-up" data-aos-duration="900">
					<h4>Organisez dès maintenant votre séminaire éco–responsable avec Hortense !</h4>
					<p>
						Offrez à vos équipes une expérience unique dans des lieux éco-responsables alliant
						charme, confort et engagement durable.
					</p>
					<div class="d-flex justify-content-center">
						<a href="https://calendly.com/servicecorporate-hortense/30-minute-meeting-clone" class="cta-button dark d-none d-md-grid ">DISCUTONS DE VOTRE PROJET</a>
					</div>
				</div>
			</div>
			<div class="dark d-md-none cta-mobile-btn">
				<a href="https://calendly.com/servicecorporate-hortense/30-minute-meeting-clone" class="cta-button">DISCUTONS DE VOTRE PROJET</a>
			</div>
		</section>
	
		<!-- Team Stay Highlights -->
		<section class="team-stay-section text-center" data-aos="fade-up" data-aos-duration="900">
			<h4 class="mb-2 mobile-title">Votre séjour d’équipe</h4>
			<h1 class=" mb-5 mobile-sub">signé Hortense</h1>
			<!-- Mobile scrollable with arrows -->
			<div class="stay-scroll-wrapper d-md-none" data-aos="fade-up" data-aos-duration="900">
				<button class="scroll-btn left" @click="scrollStayLeft">
					<img :src="arrows.right" alt="Scroll Left" class="arrow-img flipped" />
				</button>

				<div ref="stayScroll" class="stay-slider-mobile">
					<div
						class="stay-card zoom-img-containerr"
						:class="{ 'mt-4': i === 1 }"
						v-for="(stay, i) in stays"
						:key="i"
					>
						<img :src="stay.image" :alt="stay.alt" @click="showModal = true"/>
						<h4 class="raleway-bold-16" style="font-family: 'Raleway'; font-weight: 700; font-size: 16px;">{{ stay.title }}</h4>
						<p>{{ stay.text }}</p>
					</div>
				</div>

				<button class="scroll-btn right" @click="scrollStayRight">
					<img :src="arrows.right" alt="Scroll Right" class="arrow-img" />
				</button>
			</div>

			<!-- Desktop grid -->
			<div class="stay-grid d-none d-md-grid" data-aos="fade-up" data-aos-duration="900">
				<div
					class="stay-card zoom-img-containerr"
					:class="{ 'mt-5': i === 1 }"
					v-for="(stay, i) in stays"
					:key="i"
				>
					<img :src="stay.image" :alt="stay.alt" class="zoom-img" @click="showModal = true" />
					<h4 class="raleway-bold-16" style="font-family: 'Raleway'; font-weight: 700; font-size: 16px;">{{ stay.title }}</h4>
					<p>{{ stay.text }}</p>
				</div>
			</div>

		</section>

		<!-- 🌿 Responsible Message Banner -->
		<section class="responsible-message" data-aos="fade-up" data-aos-duration="900">
			<p class="merriweather-italic-24">
				<em>Ensemble, organisons votre évènement d’entreprise responsable et éthique.</em>
			</p>
		</section>
		  		<!-- Sticky CTA Footer -->
		<div class="seminar-sticky-footer" :class="{ 'hidden-on-modal': showModal }">
			<span><h4 class="mb-0 mobile-btn">ORGANISONS VOTRE ÉVÉNEMENT PROFESSIONNEL </h4></span>
			<a  href="/seminaire-eco-responsable/contact-seminaire" class="cta-button-white mobile-btn">
				<i class="fas fa-phone"></i> <h4 class="mb-0 mobile-btn">ÊTRE CONTACTÉ</h4>
			</a>
		</div>
    <ModalDialog :visible="showModal" @close="closeModal">
        <MultiStepForm @close="closeModal" />
    </ModalDialog>
  </div>
</template>

<script>
import Masonry from 'vue-masonry-css';
import SeminarCard from 'components/cards/SeminarCard.vue';
import ModalDialog from './ModalDialog.vue';
import MultiStepForm from './MultiStepForm.vue';


export default {
  name: "seminar-lodging",
  components: {
    masonry: Masonry,
    SeminarCard,
    ModalDialog,
    MultiStepForm
},
	methods: {
    closeModal() {
      this.showModal = false
    },
		filteredRegions(colIndex, totalCols) {
			return this.regions.filter((_, index) => index % totalCols === colIndex - 1);
		},
		regionImage(region) {
			return region.image_url || 'https://media.gettyimages.com/photos/bedroom-in-new-luxury-home-picture-id1194686012?k=6&m=1194686012&s=612x612&w=0&h=IX6Bjhwa5M5NtCtlKll-FFi_hn5lxrPwiUImH3fsZZ0=';
		},
		randomWidth(i) {
			const widths = [300, 360, 420, 280, 500];
			return widths[i % widths.length];
		},
		scrollLeft() {
			this.$refs.masonryScroll.scrollBy({ left: -400, behavior: 'smooth' });
		},
		scrollRight() {
			this.$refs.masonryScroll.scrollBy({ left: 400, behavior: 'smooth' });
		},
		scrollBenefitsLeft() {
			this.$refs.benefitsScroll.scrollBy({ left: -300, behavior: 'smooth' });
		},
		scrollBenefitsRight() {
			this.$refs.benefitsScroll.scrollBy({ left: 300, behavior: 'smooth' });
		},
		scrollStayLeft() {
			this.$refs.stayScroll.scrollBy({ left: -300, behavior: 'smooth' });
		},
		scrollStayRight() {
			this.$refs.stayScroll.scrollBy({ left: 300, behavior: 'smooth' });
		},
		scrolllodgingLeft() {
			this.$refs.lodgingScroll.scrollBy({ left: -400, behavior: 'smooth' });
		},
		scrolllodgingRight() {
			this.$refs.lodgingScroll.scrollBy({ left: 400, behavior: 'smooth' });
		},
	},
	data() {
		console.log('yessss')
		return {
      showModal: false,
			regions: [],
      		lodgings: [],
			benefits: [
				{
					image: "https://conversions-api-gateway-9083319738648672-s3bucket-zfjcs6au7hlj.s3.eu-west-3.amazonaws.com/S%C3%A9minaire/lieu-exception.webp",
					title: "DES LIEUX D’EXCEPTION",
					text: "Des hébergements de charme, en pleine nature, choisis pour leur atmosphère unique et leur engagement écologique."
				},
				{
					image: "https://conversions-api-gateway-9083319738648672-s3bucket-zfjcs6au7hlj.s3.eu-west-3.amazonaws.com/S%C3%A9minaire/organisation+sur-mesure.webp",
					title: "UNE ORGANISATION SUR-MESURE",
					text: "Un interlocuteur dédié pour un séminaire clé en main : hébergement, restauration, activités et logistique."
				},
				{
					image: "https://conversions-api-gateway-9083319738648672-s3bucket-zfjcs6au7hlj.s3.eu-west-3.amazonaws.com/S%C3%A9minaire/demarche-eco-responsable.webp",
					title: "UNE DÉMARCHE ÉCO-RESPONSABLE",
					text: "Des partenaires engagés, des circuits courts, et une attention constante à l’impact environnemental."
				},
				{
					image: "https://conversions-api-gateway-9083319738648672-s3bucket-zfjcs6au7hlj.s3.eu-west-3.amazonaws.com/S%C3%A9minaire/experience-porteuse-de-sens.webp",
					title: "UNE EXPÉRIENCE PORTEUSE DE SENS",
					text: "Un moment pour se retrouver, renforcer les liens et partager des valeurs durables avec vos équipes."
				}
			],
      icons: [
        {
          image: require('../../images/Groupe 151.svg'),
          alt: "Maison",
          label: "UNE SÉLECTION<br>UNIQUE DE LIEUX<br>DE CHARME"
        },
        {
          image: require('../../images/Groupe 1622.svg'),
          alt: "Checklist",
          label: "UNE<br>ORGANISATION<br>CLÉ EN MAIN"
        },
        {
          image: require('../../images/Groupe 175.svg'),
          alt: "Bien-être",
          label: "DES<br>HÉBERGEMENTS<br>RESPECTUEUX DE<br>L’ENVIRONNEMENT"
        },
        {
          image: require('../../images/Groupe 163.svg'),
          alt: "Feuille",
          label: "UNE EXPÉRIENCE<br>100% ÉCO-<br>RESPONSABLE"
        },
        {
          image: require('../../images/Groupe 158.svg'),
          alt: "Cadeau",
          label: "UN MOMENT<br>PRIVILÉGIÉ À<br>OFFRIR À VOS<br>ÉQUIPES"
        }
      ],
			stays: [
			{
				image: "https://conversions-api-gateway-9083319738648672-s3bucket-zfjcs6au7hlj.s3.eu-west-3.amazonaws.com/S%C3%A9minaire/hebergement-eco-responsable.webp",
				alt: "Hébergement éco-responsable",
				title: "DES HÉBERGEMENTS ÉCO-RESPONSABLES ET INSPIRANTS",
				text: "Chez Hortense, chaque lieu est soigneusement sélectionné pour son charme, son confort et son engagement écologique."
			},
			{
				image: "https://conversions-api-gateway-9083319738648672-s3bucket-zfjcs6au7hlj.s3.eu-west-3.amazonaws.com/S%C3%A9minaire/restauration-eco-friendly.webp",
				alt: "Restauration éco-friendly",
				title: "UNE RESTAURATION ÉCO-FRIENDLY ET SAVOUREUSE",
				text: "Menus de saison, produits bio et locaux, circuits courts, options végétariennes… Nous vous proposons une cuisine adaptée à vos envies."
			},
			{
				image: "https://conversions-api-gateway-9083319738648672-s3bucket-zfjcs6au7hlj.s3.eu-west-3.amazonaws.com/S%C3%A9minaire/activit%C3%A9s-qui-donnent-du-sens.webp",
				alt: "Activités",
				title: "DES ACTIVITÉS QUI DONNENT DU SENS",
				text: "Atelier culinaire, fresque du climat, randonnée, yoga… Nous vous aidons à composer un programme sur-mesure, tout en respectant vos valeurs."
			}
		],
		arrows: {
			right: require('../../images/Groupe 127.svg'),
		}
		};
	},
	async mounted() {
  try {
    const whatsappBtn = document.getElementById('whatsapp-button');
    if (whatsappBtn) {
      whatsappBtn.style.bottom = '80px';
    }
    const regionsRes = await fetch('/seminars/regions.json')
    if (!regionsRes.ok) throw new Error(`Regions request failed (${regionsRes.status})`)
    this.regions = await regionsRes.json()

    const lodgingsRes = await fetch('/seminars/lodgings.json')
    if (!lodgingsRes.ok) throw new Error(`Lodgings request failed (${lodgingsRes.status})`)
    this.lodgings = await lodgingsRes.json()

    console.log('fetched regions:', this.regions)
    console.log('fetched lodgings:', this.lodgings)
  } catch (error) {
    console.error('Error fetching seminar data:', error)
  }
}
};
</script>

<style scoped>
  body.map-active #navbar-main .top-bar,
  body.map-active #navbar-main #nav-phone .nav-phone {
    display: none !important;
  }
#navbar-main .top-bar{
	display: none !important;
}
#navbar-main #navbar{
	margin-top: 0px;
}
.hero-video {
  position: relative;
  width: 100%;
  height: 50vh;
  overflow: hidden;
	@media(max-width: 480px){
		height: 100vh;
	}
}

.hero-video__bg {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.hero-video__content {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  color: white;
  text-align: center;
  z-index: 2;
  text-shadow: 1px 1px 6px rgba(0, 0, 0, 0.7);
}

.why-hortense {
  background: #fff;
}

.benefits-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 2rem;
  padding: 0 2rem;
  text-align: left;
	@media(min-width: 786px){
		display: grid !important;
	}
}

.benefit-card img {
  width: 100%;
  /* border-radius: 0.5rem; */
  margin-bottom: 1rem;
  object-fit: cover;
}

.benefit-card h4 {
  font-size: 1rem;
  font-weight: bold;
  margin-bottom: 0.5rem;
  text-transform: uppercase;
}

/* .benefit-card p {
  font-size: 0.95rem;
  color: #333;
} */

.benefits-slider-mobile {
  display: flex;
  overflow-x: auto;
  scroll-snap-type: x mandatory;
  gap: 1rem;
  padding: 1rem;
  -webkit-overflow-scrolling: touch;
}

.benefits-scroll-wrapper {
  position: relative;
  display: flex;
  align-items: center;
}

.benefits-slider-mobile .benefit-card {
  flex: 0 0 80%;
  scroll-snap-align: start;
  min-width: 260px;
  max-width: 300px;
  background: white;
  border-radius: 0.5rem;
	box-shadow: none;
	max-width: 19rem;
}
.afw-semibold{
	font-weight: 600;
}

/* .benefits-slider-mobile .benefit-card:first-child {
  padding-left: 1.5rem;
} */
.benefits-slider-mobile .benefit-card img {
  width: 100%;
  object-fit: cover;
}

.benefits-slider-mobile .benefit-card h4 {
  font-weight: bold;
  margin: 0.5rem 1rem 0.3rem;
  font-size: 1rem;
  text-transform: uppercase;
}

.benefits-slider-mobile .benefit-card p {
  font-size: 0.9rem;
  margin: 0 1rem 1rem;
  color: #333;
}

.cta-button {
  display: inline-block;
  background-color: #3B6152;
  color: white;
  padding: 0.8rem 2rem;
	font-size: 13px;
  font-weight: bold;
  text-decoration: none;
  border-radius: 0px;
  transition: background-color 0.3s;
	@media(min-width: 786px){
		display: grid !important;
	}
	@media(max-width: 480px){
		padding-top: 1rem;
		padding-bottom: 1rem;
	}
}

.cta-button:hover {
  background-color: #244c34;
}

/* 💡 Icon Grid */
.icon-grid {
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  gap: 3rem;
  padding: 2rem 1rem;
}

.icon-card {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  width: 230px;
  text-align: center;
}

.icon-card img {
  width: 50px;
  margin-bottom: 0.5rem;
}

.icon-card p {
  font-size: 0.85rem;
  font-weight: bold;
  text-transform: uppercase;
  line-height: 1.4;
  margin: 0;
}

.seminar-h4-fs{
	font-size: 13px;
}

.icon-wrapper {
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
}

@media (max-width: 768px) {
  .icon-grid {
    display: flex;
    flex-wrap: nowrap;
    gap: 2rem;
    padding: 1rem;
    min-width: max-content;
  }

  .icon-card {
	flex: 0 0 auto;
	width: 160px;
	display: flex;
	flex-direction: column;
	align-items: center;
	text-align: center;
	padding: 0.5rem;
  }

  .icon-card img {
  max-width: 100%;
  height: auto;
  margin-bottom: 0.5rem;
}
}

/* 🚘 Horizontal Slider */
.destinations-slider {
	min-height: 200px;
  background: #fff;
  padding: 3rem 1rem;
}

.slider-container {
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
  padding-bottom: 1rem;
}

.slider-wrapper {
  display: flex;
  gap: 1rem;
  padding: 1rem;
  min-width: max-content;
}

.region-card {
  flex: 0 0 auto;
  width: 280px;
  height: 200px;
  position: relative;
  overflow: hidden;
  border-radius: 0.5rem;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);
}

.region-card-img {
  width: 100%;
  height: 100%;
  background-size: cover;
  background-position: center;
  display: flex;
  align-items: flex-end;
  justify-content: center;
  padding: 1rem;
}

.region-name-overlay {
  color: white;
  font-weight: bold;
  font-size: 1rem;
  text-shadow: 0 0 8px rgba(0, 0, 0, 0.7);
  text-transform: uppercase;
  text-align: center;
}

/* new mansory grid CSS*/
.region-card-masonry {
  border-radius: 0.5rem;
  overflow: hidden;
  position: relative;
  height: 100%;
}

.region-card-masonry .region-card-img {
  width: 100%;
  padding-top: 66.66%; /* 3:2 ratio */
  background-size: cover;
  background-position: center;
  position: static;
}

.region-card-masonry .region-name-overlay {
  position: absolute;
  bottom: 1rem;
  left: 1rem;
  right: 1rem;
  color: white;
  font-weight: bold;
  text-shadow: 0 0 6px rgba(0, 0, 0, 0.8);
  text-transform: uppercase;
  font-size: 1rem;
  text-align: left;
}
/* new mansory grid CSS end*/
.eco-cta-section {
  background-color: #f8f9f8;
  padding: 4rem 1rem;
	@media(max-width: 786px){
		padding-bottom: 2rem;
	}
}

.cta-mobile-btn{
	display: flex;
	flex-direction: row;
	justify-content: center;
	margin-top: 2rem;
}

.eco-cta-wrapper {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  max-width: 1200px;
  margin: 0 auto;
  gap: 2rem;
	@media(max-width: 768px){
		flex-direction: column-reverse;
	}
}

.eco-cta-image {
  flex: 1 1 45%;
  position: relative;
}

.eco-cta-image img {
  width: 100%;
  border-radius: 0.5rem;
  object-fit: cover;
}

.eco-cta-text-overlay {
  position: absolute;
  bottom: 1.5rem;
  left: 1.5rem;
  color: white;
  font-size: 1.2rem;
  font-weight: bold;
  text-shadow: 1px 1px 4px rgba(0, 0, 0, 0.7);
  font-family: 'Georgia', serif;
}

.eco-cta-text {
  flex: 1 1 45%;
	text-align: center;
}

.eco-cta-text h3 {
  font-size: 1.5rem;
  margin-bottom: 1rem;
}

.eco-cta-text p {
  font-size: 1rem;
  margin-bottom: 1.5rem;
  color: #333;
}

.cta-button.dark {
  background-color: #3B6152;
  color: white;
}

.team-stay-section {
  padding: 3rem 1rem;
  background-color: #fff;
}

.stay-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 2rem;
  max-width: 1200px;
  margin: 0 auto;
  padding: 1rem 0;
	@media(min-width: 786px){
		display: grid !important;
	}
}

.stay-card {
  text-align: left;
}

.stay-card img {
  width: 100%;
  margin-bottom: 1rem;
  object-fit: cover;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
}

.stay-card h4 {
  font-weight: bold;
  font-size: 1rem;
  text-transform: uppercase;
  margin-bottom: 0.5rem;
}

.stay-card p {
  font-size: 0.95rem;
  color: #333;
}

.stay-slider-mobile {
  display: flex;
  overflow-x: auto;
  scroll-snap-type: x mandatory;
  gap: 1rem;
  padding: 1rem;
  -webkit-overflow-scrolling: touch;
}

.stay-slider-mobile .stay-card {
  flex: 0 0 80%;
  scroll-snap-align: start;
  min-width: 260px;
  max-width: 300px;
  background: white;
}
.stay-slider-mobile .stay-card:first-child{
	padding-left: 0px;
}

.stay-slider-mobile .stay-card img {
  width: 100%;
  /* border-radius: 0.5rem 0.5rem 0 0; */
  object-fit: cover;
}

.stay-slider-mobile .stay-card h4 {
  font-weight: bold;
  margin: 0.5rem 1rem 0.3rem;
  font-size: 1rem;
  text-transform: uppercase;
}

.stay-slider-mobile .stay-card p {
  font-size: 0.9rem;
  margin: 0 1rem 1rem;
  color: #333;
}


.responsible-message {
  background-color: #f2f7f3; /* Soft green */
  padding: 2rem 1rem;
  text-align: center;
}

.responsible-message p {
  font-size: 1.5rem;
  font-style: italic;
  color: #2e2e2e;
  margin: 0;
}

.seminar-sticky-footer {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  background-color: #3B6152;
  color: white;
  padding: 1rem 2rem;
  font-weight: bold;
  z-index: 9999;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
  box-shadow: 0 -2px 6px rgba(0, 0, 0, 0.1);
}
.seminar-sticky-footer span {
  font-size: 1rem;
}
.cta-button-white {
  background-color: white;
  color: #3B6152;
  padding: 0.6rem 1.2rem;
  border-radius: 2rem;
  font-weight: bold;
  text-decoration: none;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  margin-left: 4rem;
}
@media(max-width: 786px) {
  .seminar-sticky-footer {
    padding: 0.8rem 1rem;
    flex-direction: column;
  }
  .cta-button-white {
    margin-left: 0;
  }
}

.cta-button-white i {
  font-size: 1rem;
}
.seminar-lodgings-page {
  padding-bottom: 90px; /* Space for fixed footer */
}

.seminar-lodgings-slider {
  background: #fff;
  padding: 0.5rem 0.5rem;
  position: relative;
  display: flex;
  align-items: center; 
}

.lodging-slider-wrapper {
  display: flex;
  overflow-x: auto;
  gap: 8.5rem;
  scroll-snap-type: x mandatory;
  padding-bottom: 1rem;
  flex: 1;
  scroll-behavior: smooth;
}

.lodging-slider-wrapper > * {
  scroll-snap-align: start;
  flex: 0 0 auto;
  width: 320px;
}
.seminar-lodgings-page {
  font-family: 'Raleway', sans-serif;
}

.seminar-lodgings-page h1,
.seminar-lodgings-page h2,
.seminar-lodgings-page h3,
.seminar-lodgings-page h4 {
  font-family: 'Merriweather', serif;
}
.raleway-reg-p15 {
  font-family: 'Raleway', sans-serif;
  font-size: 15px;
  font-weight: 400;
}

.merriweather-reg-40 {
  font-family: 'Merriweather', serif;
  font-size: 40px;
  font-weight: 400;
}
.horizontal-masonry-container {
  display: flex;
  overflow-x: auto;
  gap: 1rem;
  padding-bottom: 2rem;
}

.masonry-column {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  min-width: 250px;
}

.region-card-masonry {
  width: 250px;
  border-radius: 0.5rem;
  overflow: hidden;
  position: relative;
}

.region-card-img {
  width: 100%;
  padding-top: 66.66%; /* 3:2 aspect ratio */
  background-size: cover;
  background-position: center;
  position: static;
}

.region-name-overlay {
  position: absolute;
  bottom: 1rem;
  left: 1rem;
  right: 1rem;
  color: white;
  font-weight: bold;
  text-shadow: 0 0 6px rgba(0, 0, 0, 0.8);
  text-transform: uppercase;
  font-size: 1rem;
  text-align: left;
}
.horizontal-masonry-scroll {
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
  display: flex;
  flex-direction: column;
  gap: 1rem;
  padding-bottom: 2rem;
}

.masonry-row {
  display: flex;
  flex-direction: row;
  gap: 1rem;
  min-width: max-content;
}

.region-card-masonry {
  height: 250px;
  border-radius: 0.5rem;
  overflow: hidden;
  background: #ddd;
  scroll-snap-align: start;
  flex-shrink: 0;
}

.region-card-img {
  width: 100%;
  height: 100%;
  background-size: cover;
  background-position: center;
  position: static;
}

.region-name-overlay {
  position: absolute;
  bottom: 1rem;
  left: 1rem;
  right: 1rem;
  color: white;
  font-weight: bold;
  font-size: 1rem;
  text-shadow: 0 0 6px rgba(0, 0, 0, 0.8);
  text-transform: uppercase;
  text-align: left;
}

.masonry-scroll-wrapper {
  position: relative;
}
.scroll-btn {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  background: white;
  border: none;
  padding: 0.4rem;
  z-index: 5;
  cursor: pointer;
  box-shadow: 0 0 5px rgba(0, 0, 0, 0.15);
  border-radius: 50%;
  transition: background 0.3s;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 30px;
  height: 30px;
}


.scroll-btn.left {
  left: 0;
}

.scroll-btn.right {
  right: 0;
}

.scroll-btn:hover {
  background-color: #eee;
}

.scroll-btn:hover {
  background: #f2f2f2;
}

.scroll-btn.left {
  left: 0px;
}

.scroll-btn.right {
  right: 0px;
}

.arrow-img {
  width: 24px;
  height: 24px;
}

.arrow-img.flipped {
  transform: scaleX(-1);
}

.stay-scroll-wrapper {
  position: relative;
  display: flex;
  align-items: center;
}
.mobile-btn{
	@media(max-width: 480px){
		font-size: .8rem;
	}
}
@media (max-width: 485px) {
	.mobile-title{
		font: normal normal normal 18px/40px Merriweather;
	}
	.mobile-sub{
		font: normal normal normal 32px/40px Merriweather;
	}
}

.zoom-img-containerr {
  .zoom-img:hover {
    transform: scale(1.08);
  }
}

@media (max-width: 480px) {
  .seminar-sticky-footer.hidden-on-modal {
    display: none !important;
  }
}

</style>
